const escapeSpecialChars = (text) => {
    return text
        .replaceAll("%", "％")
        .replaceAll("+", "＋")
};

export default escapeSpecialChars;